
import { Vue, Component, Prop } from 'vue-property-decorator';
import { FormItemConf } from './index';
import { testPhone, testID } from '@/common/ts/utils';
import generateConfig from './FormConfig';
import FormItem from './FormItem.vue';
import { Toast, Dialog, Popup } from 'vant';
import { isWeiXin } from '@/common/ts/common';

Vue.use(Toast).use(Dialog).use(Popup);
@Component({
  components: {
    FormItem,
  },
})
export default class SyForm extends Vue {
  @Prop({ required: true }) config!: FormItemConf[];
  @Prop({ required: false, default: '上传' }) btnTxt!: string;
  @Prop({ required: false, default: false }) mustInAppLogin!: boolean;
  @Prop({
    default: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.news.shangyounews',
  })
  downLoadUrl!: string;
  pointOut = false;
  // config: FormItemConf[] = generateConfig();

  // 上传图片子组件
  get imgUploadComp() {
    const tempComp: any = this.$refs.formItemimage;
    return tempComp ? tempComp[0] : undefined;
  }
  // 上传视频子组件
  get videoUploadComp() {
    const tempComp: any = this.$refs.formItemvideo;
    return tempComp ? tempComp[0] : undefined;
  }
  // 文本编辑子组件
  get editorComp() {
    const tempComp: any = this.$refs.formItemtext;
    return tempComp ? tempComp[0] : undefined;
  }

  async handleUpload() {
    // 判断必须在app且登录
    if (this.mustInAppLogin) {
      if (!window.udid) {
        Dialog.confirm({
          title: '友情提示',
          message: '请在上游新闻App进行报名',
          confirmButtonText: '还没装？一步安装',
          cancelButtonText: '我已安装过',
          closeOnClickOverlay: true,
        })
          .then(() => {
            window.location.href = this.downLoadUrl;
          })
          .catch(() => {
            if (isWeiXin() === true) {
              this.pointOut = true;
            } else {
              window.location.href =
                'shangyounews://{"dt":"7","url":"' +
                document.location.href +
                '"}';
            }
          });
        return;
      }
      const token = window.gettoken();
      if (token === 'null' || !token) {
        if (parseFloat(window.version) >= 4.5) {
          window.handleMessage('{"action":"mUserLogin","data":""}');
        } else {
          window.location.href = 'client:logout';
        }
        return;
      }
    }

    // 判断文件上传的表单是否满足需求 如：最少需要几张图
    const fileLengthPass = await this._checkFileLength();
    if (!fileLengthPass) {
      return;
    }
    // 循环表单判断value 、 value是否合格
    const validValuePass = await this._checkValidValue();
    if (!validValuePass) {
      return;
    }
    await this._uploadFile();
  }

  _checkFileLength(): boolean {
    for (const itemConf of this.config) {
      if (
        (itemConf.type === 'image' && itemConf.require) ||
        (itemConf.type === 'video' && itemConf.require)
      ) {
        if (
          itemConf.fileRules === undefined ||
          itemConf.fileRules.minLength === undefined
        ) {
          throw new Error(
            '上传文件类型fileRules/fileRules.minLength参数必须配置',
          );
          return false;
        }
        // 获取当前已选中待上传的文件长度
        const IMG_LENGTH = this.imgUploadComp
          ? this.imgUploadComp.fileLength
          : 0;
        const VIDEO_LENGTH = this.videoUploadComp
          ? this.videoUploadComp.fileLength
          : 0;

        const tempTypeLength =
          itemConf.type === 'image' ? IMG_LENGTH : VIDEO_LENGTH;
        const tempTip = itemConf.type === 'image' ? '张图片' : '个视频';
        if (tempTypeLength < itemConf.fileRules.minLength) {
          Toast(`至少需要上传${itemConf.fileRules.minLength}${tempTip}`);
          return false;
        }
      }
    }
    return true;
  }

  _checkValidValue(): boolean {
    for (const itemConf of this.config) {
      if (itemConf.type === 'text') {
        const value = this.editorComp
          ? this.editorComp.getContent(itemConf.pureText)
          : '';
        const temp = value.replace(/\s/g, '');

        if (!temp) {
          Toast(itemConf.placeholder);
          return false;
        }
        if (
          itemConf.textMaxLength &&
          itemConf.pureText &&
          value.length > itemConf.textMaxLength
        ) {
          Toast(`${itemConf.title}最大限制${itemConf.textMaxLength}字数`);
          return false;
        }
        this.config.forEach((item, index) => {
          if (itemConf.field === item.field) {
            item.value = value;
          }
        });
      }

      // 判断当前的表单是否有值 除：image、video、text
      if (
        itemConf.require &&
        !itemConf.value &&
        itemConf.type !== 'image' &&
        itemConf.type !== 'video'
      ) {
        Toast(itemConf.placeholder);
        return false;
      }
      // 判断输入框字数限制
      if (
        itemConf.type === 'input' &&
        itemConf.textMaxLength &&
        itemConf.value &&
        itemConf.value.length > itemConf.textMaxLength
      ) {
        Toast(`${itemConf.title}最大限制${itemConf.textMaxLength}字数`);
        return false;
      }

      // 判断input的phone是否合格
      if (
        itemConf.type === 'input' &&
        itemConf.ruleType &&
        itemConf.ruleType === 'PHONE' &&
        !testPhone(itemConf.value)
      ) {
        Toast('请输入正确的手机号');
        return false;
      }
      // 判断input的 id 是否合格
      if (
        itemConf.type === 'input' &&
        itemConf.ruleType &&
        itemConf.ruleType === 'ID' &&
        !testID(itemConf.value)
      ) {
        Toast('请输入正确的身份证');
        return false;
      }
    }
    return true;
  }

  async _uploadFile() {
    Toast.loading({
      message: '上传中...',
      duration: 0,
      forbidClick: true,
    });
    if (this.imgUploadComp || this.videoUploadComp) {
      const imgPaths = this.imgUploadComp
        ? await (this.imgUploadComp as FormItem).uploadFile()
        : [];
      const videoPaths = this.videoUploadComp
        ? await (this.videoUploadComp as FormItem).uploadFile()
        : [];
      this.config.forEach((item, index) => {
        if (item.type === 'image') {
          item.value = imgPaths;
        }
        if (item.type === 'video') {
          item.value = videoPaths;
        }
      });
      Toast.clear();
      const data = this._returnData();
      this.$emit('getData', data);
    }
  }

  _returnData() {
    return this.config.reduce((obj, itemConf) => {
      return {
        [itemConf.field]: itemConf.value,
        ...obj,
      };
    }, {});
  }
}
